module.exports = __webpack_public_path__ + "static/frequentis_logo-13464d37d5a7a69b2b323e62e0ea2733.png";